import styled from 'styled-components';


export const RaiseMoneySection = styled.section`
    width: 100%;
    
    @media screen and (max-width: 1024px){ 
        padding-top: 60px;
    }
    @media screen and (max-width: 991px){ 
        padding-top: 40px;
    }

    .row {
        align-items: center;
    }
    .search-header{
        display:none;
    }
    p {
        padding-bottom: 25px;
        &:last-child{
            padding-bottom: 0px;
        }
    }
    .raise-money-banner{
        max-width: inherit;
        white-space: nowrap;

        @media screen and (max-width: 1200px){ 
            white-space: inherit;
        }
    }
    .raise-money-text{
        max-width: inherit;
    }
`;

export const CheckYourDonationsSection = styled.section`
    width: 100%;
    background: #FFFFFF;
    padding: 50px 0px 30px;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 26px;

    @media screen and (max-width: 575px){ 
        font-size: 16px;
        line-height: 24px;
        padding: 40px 0px 30px;
    }

    .donations-box-wrap{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        row-gap: 20px;
        margin-bottom: 50px;
    
        @media screen and (max-width: 991px){ 
            row-gap: 70px;
        }
        @media screen and (max-width: 767px){ 
            row-gap: 50px;
        }
        @media screen and (max-width: 575px){ 
            margin-bottom: 40px;
        }
    }
`;

export const CheckYourDonationsTitle = styled.h2`
    color: #333333;
    font-size: 30px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 42px;
    margin-bottom: 15px;
    
    @media screen and (max-width: 991px){ 
        font-size: 26px;
        line-height: 38px;
    }

    @media screen and (max-width: 575px){ 
        font-size: 24px;
        line-height: 36px;
    }
`;

export const CheckYourDonationsText = styled.p`
    padding-bottom: 20px;
    margin-bottom: 0;

    a{
        color: #01606F;
        text-decoration: none;
    }
`;

export const ReviewSpanText = styled.span`
    color: #01606F;
    font-size: 18px;
    font-family: "Jost", sans-serif;
    line-height: 27px;
    font-weight: 700;
    cursor: pointer;
`;

export const CheckYourDonationsStrong = styled.strong`
    color: #01606F;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 26px;
`;

export const DonationsBoxWrap = styled.div`
    background: #EFEFEF;
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 500;
    line-height: 26px;
    border-radius: 15px;
    padding: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 20px 23px;
    flex-wrap: wrap;
    position: relative;

    @media screen and (max-width: 575px){
        font-size: 16px;
        line-height: 24px;
    }

    &.donations-box-odd{
        &:before{
            content: '';
            position: absolute;
            width: 316px;
            height: 70px;
            border: 2px dashed #33A7AE;
            border-left: none;
            border-bottom: none;
            right: -316px;
            top: 120%;
            bottom: 0;
            margin: auto;
            transform: translateY(-50%);

            @media screen and (max-width: 991px){ 
                width: 1px;
                height: 70px;
                right: 0;
                left: 0;
                bottom: -120px;
            }

            @media screen and (max-width: 767px){
                height: 50px;
                bottom: -80px;
            }
        }
    }

    &.donations-box-even{        
        &:after{
            content: '';
            position: absolute;
            width: 316px;
            height: 140px;
            border: 2px dashed #33A7AE;
            border-right: none;
            border-bottom: none;
            left: -316px;
            top: 50%;
            bottom: auto;
            margin: auto;
            transform: translateY(0%);

            @media screen and (max-width: 991px){
                width: 1px;
                height: 70px;
                left: 0px;
                right: 0;
                top: auto;
                bottom: -70px;
            }
            @media screen and (max-width: 767px){
                height: 50px;
                bottom: -50px;
            }
        }
    }
`;

export const DonationsBox = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 20px 23px;

    @media screen and (max-width: 767px){ 
        align-items: flex-start;
        gap: 15px;
    }
`;

export const DonationsCount = styled.div`
    width: 80px;
    min-width: 80px;
    height: 80px;
    background: #33A7AE;
    border-radius: 15px;
    color: #fff;
    font-size: 30px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 42px;
    display: flex;
    justify-content: center;
    align-items: center;

    @media screen and (max-width: 991px){ 
        width: 60px;
        min-width: 60px;
        height: 60px;
        font-size: 26px;
        line-height: 38px;
    }

    @media screen and (max-width: 575px){ 
        width: 40px;
        min-width: 40px;
        height: 40px;
        font-size: 22px;
        line-height: 34px;
        border-radius: 8px;
    }

`;

export const DonationsContent = styled.p`
    margin: 0;
`;
export const DonationsContentStrong = styled.strong`
    color: #01606F;
    font-weight: 700; 
`;

export const DonationImage = styled.div`
    width: 100%;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0px 3px 5px #0000000D;
    img{
        width: 100%;
        height: 100%;
        display: block;
    }
`;

export const CheckYourDonationsStrongBlack = styled.strong`
    font-wright: 700;
    color: #333333;
`;